"use client";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import * as i from "@radix-ui/react-accordion";
import { cn as e } from "./index.es21.js";
import "./index.es2.js";
import "react";
import "./index.es4.js";
import "tailwind-merge";
import "./index.es6.js";
import "./index.es7.js";
import "./index.es8.js";
import "./index.es9.js";
import "./index.es10.js";
import "./index.es11.js";
import "./index.es13.js";
import "./index.es14.js";
import "./index.es15.js";
import "./index.es16.js";
import "./index.es17.js";
import "@radix-ui/react-tabs";
import { Icon as c } from "./index.es20.js";
const T = ({ ...t }) => /* @__PURE__ */ o(i.Root, { "data-slot": "accordion", ...t });
function z({ className: t, ...r }) {
  return /* @__PURE__ */ o(
    i.Item,
    {
      "data-slot": "accordion-item",
      className: e("border-b last:border-b-0", t),
      ...r
    }
  );
}
function D({ className: t, iconClassName: r, children: n, ...a }) {
  return /* @__PURE__ */ o(i.Header, { children: /* @__PURE__ */ s(
    i.Trigger,
    {
      "data-slot": "accordion-trigger",
      className: e(
        "focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500 flex flex-1 items-start justify-between gap-4 text-left hover:cursor-pointer transition-all outline-none disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>svg]:rotate-180",
        t
      ),
      ...a,
      children: [
        n,
        /* @__PURE__ */ o(
          c,
          {
            name: "chevronDown",
            className: e(
              "pointer-events-none size-3 translate-y-0.5 transition-transform duration-200",
              r
            )
          }
        )
      ]
    }
  ) });
}
function H({ className: t, children: r, ...n }) {
  return /* @__PURE__ */ o(
    i.Content,
    {
      "data-slot": "accordion-content",
      className: "data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-sm",
      ...n,
      children: /* @__PURE__ */ o("div", { className: e("", t), children: r })
    }
  );
}
export {
  H as AccordionContent,
  z as AccordionItem,
  T as AccordionRoot,
  D as AccordionTrigger
};
